import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';

import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';
import { SUBSCRIPTION_MODULE } from '../../configs/moduleNames';

export const LOAD_SUBSCRIPTION_LIST = '_LOAD_SUBSCRIPTION_LIST';
export const LOAD_SUBSCRIPTION_BY_ID = '_LOAD_SUBSCRIPTION_BY_ID';
export const CREATE_SUBSCRIPTION = '_CREATE_SUBSCRIPTION';
export const EDIT_SUBSCRIPTION = '_EDIT_SUBSCRIPTION';
export const DELETE_SUBSCRIPTION = '_DELETE_SUBSCRIPTION';

export const LOAD_SUBSCRIPTION_TYPE_LIST = '_LOAD_SUBSCRIPTION_TYPE_LIST';
export const LOAD_SUBSCRIPTION_TYPE_BY_ID = '_LOAD_SUBSCRIPTION_TYPE_BY_ID';
export const CREATE_SUBSCRIPTION_TYPE = '_CREATE_SUBSCRIPTION_TYPE';
export const EDIT_SUBSCRIPTION_TYPE = '_EDIT_SUBSCRIPTION_TYPE';
export const DELETE_SUBSCRIPTION_TYPE = '_DELETE_SUBSCRIPTION_TYPE';

export const LOAD_INTERVAL_LIST = '_LOAD_INTERVAL_LIST';
export const LOAD_CURRENT_INTERVAL_BY_ID = '_LOAD_CURRENT_INTERVAL_BY_ID';
export const CREATE_INTERVAL = '_CREATE_INTERVAL';
export const EDIT_INTERVAL = '_EDIT_INTERVAL';
export const DELETE_INTERVAL = '_DELETE_INTERVAL';

export const CREATE_BLACK_WHITES = '_CREATE_BLACK_WHITES';
export const DELETE_BLACK_WHITES = '_DELETE_BLACK_WHITES';
export const EDIT_BLACK_WHITES = '_EDIT_BLACK_WHITES';
export const LOAD_WHITES_LIST = '_LOAD_WHITES_LIST';
export const LOAD_BLACK_LIST = '_LOAD_BLACK_LIST';
export const LOAD_CURRENT_BLACK_WHITES_BY_ID = '_LOAD_CURRENT_BLACK_WHITES_BY_ID';
export const CHECK_BLACK_WHITES_MODULE_STATUS = '_CHECK_BLACK_WHITES_MODULE_STATUS';
export const SET_BLACK_WHITES_MODULE_STATUS = '_SET_BLACK_WHITES_MODULE_STATUS';

export const createSubscription = createDeferredAction(SUBSCRIPTION_MODULE + CREATE_SUBSCRIPTION);
export const createSubscriptionSuccessful = createAction(SUBSCRIPTION_MODULE + CREATE_SUBSCRIPTION + SUCCESSFUL);
export const createSubscriptionFailed = createAction(SUBSCRIPTION_MODULE + CREATE_SUBSCRIPTION + FAILED);

export const editSubscription = createDeferredAction(SUBSCRIPTION_MODULE + EDIT_SUBSCRIPTION);
export const editSubscriptionSuccessful = createAction(SUBSCRIPTION_MODULE + EDIT_SUBSCRIPTION + SUCCESSFUL);
export const editSubscriptionFailed = createAction(SUBSCRIPTION_MODULE + EDIT_SUBSCRIPTION + FAILED);

export const deleteSubscription = createDeferredAction(SUBSCRIPTION_MODULE + DELETE_SUBSCRIPTION);
export const deleteSubscriptionSuccessful = createAction(SUBSCRIPTION_MODULE + DELETE_SUBSCRIPTION + SUCCESSFUL);
export const deleteSubscriptionFailed = createAction(SUBSCRIPTION_MODULE + DELETE_SUBSCRIPTION + FAILED);

export const loadSubscriptionList = createDeferredAction(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_LIST);
export const loadSubscriptionListBegin = createAction(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_LIST + BEGIN);
export const loadSubscriptionListSuccessful = createAction(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_LIST + SUCCESSFUL);
export const loadSubscriptionListFailed = createAction(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_LIST + FAILED);

export const loadSubscriptionById = createDeferredAction(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_BY_ID);
export const loadSubscriptionByIdSuccessful = createAction(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_BY_ID + SUCCESSFUL);
export const loadSubscriptionByIdFailed = createAction(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_BY_ID + FAILED);
export const loadSubscriptionByIdClear = createAction(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_BY_ID + CLEAR);

export const loadIntervalList = createDeferredAction(SUBSCRIPTION_MODULE + LOAD_INTERVAL_LIST);
export const loadIntervalListBegin = createAction(SUBSCRIPTION_MODULE + LOAD_INTERVAL_LIST + BEGIN);
export const loadIntervalListSuccessful = createAction(SUBSCRIPTION_MODULE + LOAD_INTERVAL_LIST + SUCCESSFUL);
export const loadIntervalListFailed = createAction(SUBSCRIPTION_MODULE + LOAD_INTERVAL_LIST + FAILED);

export const loadCurrentIntervalById = createDeferredAction(SUBSCRIPTION_MODULE + LOAD_CURRENT_INTERVAL_BY_ID);
export const loadCurrentIntervalByIdSuccessful = createAction(SUBSCRIPTION_MODULE + LOAD_CURRENT_INTERVAL_BY_ID + SUCCESSFUL);
export const loadCurrentIntervalByIdFailed = createAction(SUBSCRIPTION_MODULE + LOAD_CURRENT_INTERVAL_BY_ID + FAILED);
export const loadCurrentIntervalByIdClear = createAction(SUBSCRIPTION_MODULE + LOAD_CURRENT_INTERVAL_BY_ID + CLEAR);

export const deleteInterval = createDeferredAction(SUBSCRIPTION_MODULE + DELETE_INTERVAL);
export const deleteIntervalSuccessful = createAction(SUBSCRIPTION_MODULE + DELETE_INTERVAL + SUCCESSFUL);
export const deleteIntervalFailed = createAction(SUBSCRIPTION_MODULE + DELETE_INTERVAL + FAILED);

export const createInterval = createDeferredAction(SUBSCRIPTION_MODULE + CREATE_INTERVAL);
export const createIntervalSuccessful = createAction(SUBSCRIPTION_MODULE + CREATE_INTERVAL + SUCCESSFUL);
export const createIntervalFailed = createAction(SUBSCRIPTION_MODULE + CREATE_INTERVAL + FAILED);

export const editInterval = createDeferredAction(SUBSCRIPTION_MODULE + EDIT_INTERVAL);
export const editIntervalSuccessful = createAction(SUBSCRIPTION_MODULE + EDIT_INTERVAL + SUCCESSFUL);
export const editIntervalFailed = createAction(SUBSCRIPTION_MODULE + EDIT_INTERVAL + FAILED);

export const createSubscriptionType = createDeferredAction(SUBSCRIPTION_MODULE + CREATE_SUBSCRIPTION_TYPE);
export const createSubscriptionTypeSuccessful = createAction(SUBSCRIPTION_MODULE + CREATE_SUBSCRIPTION_TYPE + SUCCESSFUL);
export const createSubscriptionTypeFailed = createAction(SUBSCRIPTION_MODULE + CREATE_SUBSCRIPTION_TYPE + FAILED);

export const editSubscriptionType = createDeferredAction(SUBSCRIPTION_MODULE + EDIT_SUBSCRIPTION_TYPE);
export const editSubscriptionTypeSuccessful = createAction(SUBSCRIPTION_MODULE + EDIT_SUBSCRIPTION_TYPE + SUCCESSFUL);
export const editSubscriptionTypeFailed = createAction(SUBSCRIPTION_MODULE + EDIT_SUBSCRIPTION_TYPE + FAILED);

export const deleteSubscriptionType = createDeferredAction(SUBSCRIPTION_MODULE + DELETE_SUBSCRIPTION_TYPE);
export const deleteSubscriptionTypeSuccessful = createAction(SUBSCRIPTION_MODULE + DELETE_SUBSCRIPTION_TYPE + SUCCESSFUL);
export const deleteSubscriptionTypeFailed = createAction(SUBSCRIPTION_MODULE + DELETE_SUBSCRIPTION_TYPE + FAILED);

export const loadSubscriptionTypeList = createDeferredAction(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_TYPE_LIST);
export const loadSubscriptionTypeListBegin = createAction(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_TYPE_LIST + BEGIN);
export const loadSubscriptionTypeListSuccessful = createAction(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_TYPE_LIST + SUCCESSFUL);
export const loadSubscriptionTypeListFailed = createAction(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_TYPE_LIST + FAILED);

export const loadSubscriptionTypeById = createDeferredAction(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_TYPE_BY_ID);
export const loadSubscriptionTypeByIdSuccessful = createAction(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_TYPE_BY_ID + SUCCESSFUL);
export const loadSubscriptionTypeByIdFailed = createAction(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_TYPE_BY_ID + FAILED);
export const loadSubscriptionTypeByIdClear = createAction(SUBSCRIPTION_MODULE + LOAD_SUBSCRIPTION_TYPE_BY_ID + CLEAR);

export const createBlackWhites = createDeferredAction(SUBSCRIPTION_MODULE + CREATE_BLACK_WHITES);
export const createBlackWhitesSuccessful = createAction(SUBSCRIPTION_MODULE + CREATE_BLACK_WHITES + SUCCESSFUL);
export const createBlackWhitesFailed = createAction(SUBSCRIPTION_MODULE + CREATE_BLACK_WHITES + FAILED);

export const deleteBlackWhites = createDeferredAction(SUBSCRIPTION_MODULE + DELETE_BLACK_WHITES);
export const deleteBlackWhitesSuccessful = createAction(SUBSCRIPTION_MODULE + DELETE_BLACK_WHITES + SUCCESSFUL);
export const deleteBlackWhitesFailed = createAction(SUBSCRIPTION_MODULE + DELETE_BLACK_WHITES + FAILED);

export const editBlackWhites = createDeferredAction(SUBSCRIPTION_MODULE + EDIT_BLACK_WHITES);
export const editBlackWhitesSuccessful = createAction(SUBSCRIPTION_MODULE + EDIT_BLACK_WHITES + SUCCESSFUL);
export const editBlackWhitesFailed = createAction(SUBSCRIPTION_MODULE + EDIT_BLACK_WHITES + FAILED);

export const loadWhitesList = createDeferredAction(SUBSCRIPTION_MODULE + LOAD_WHITES_LIST);
export const loadWhitesListBegin = createAction(SUBSCRIPTION_MODULE + LOAD_WHITES_LIST + BEGIN);
export const loadWhitesListSuccessful = createAction(SUBSCRIPTION_MODULE + LOAD_WHITES_LIST + SUCCESSFUL);
export const loadWhitesListFailed = createAction(SUBSCRIPTION_MODULE + LOAD_WHITES_LIST + FAILED);

export const loadBlackList = createDeferredAction(SUBSCRIPTION_MODULE + LOAD_BLACK_LIST);
export const loadBlackListBegin = createAction(SUBSCRIPTION_MODULE + LOAD_BLACK_LIST + BEGIN);
export const loadBlackListSuccessful = createAction(SUBSCRIPTION_MODULE + LOAD_BLACK_LIST + SUCCESSFUL);
export const loadBlackListFailed = createAction(SUBSCRIPTION_MODULE + LOAD_BLACK_LIST + FAILED);

export const loadCurrentBlackWhitesById = createDeferredAction(SUBSCRIPTION_MODULE + LOAD_CURRENT_BLACK_WHITES_BY_ID);
export const loadCurrentBlackWhitesByIdSuccessful = createAction(SUBSCRIPTION_MODULE + LOAD_CURRENT_BLACK_WHITES_BY_ID + SUCCESSFUL);
export const loadCurrentBlackWhitesByIdFailed = createAction(SUBSCRIPTION_MODULE + LOAD_CURRENT_BLACK_WHITES_BY_ID + FAILED);
export const loadCurrentBlackWhitesByIdClear = createAction(SUBSCRIPTION_MODULE + LOAD_CURRENT_BLACK_WHITES_BY_ID + CLEAR);

export const checkBlackWhitesModuleStatus = createAction(SUBSCRIPTION_MODULE + CHECK_BLACK_WHITES_MODULE_STATUS);
export const setBlackWhitesModuleStatus = createAction(SUBSCRIPTION_MODULE + SET_BLACK_WHITES_MODULE_STATUS);
